<template>
  <Screen>
    <AppBar :title="title" />
    <Breadcrumbs
      :links="[
        {
          to: $route('admin.blogs.index'),
          title: 'Blogs',
        },
      ]"
      :title="title"
    />
    <div class="card card-body">
      <form action="" method="post" @submit.prevent="submit" v-if="formSet">
        <div class="row">
          <div class="col-lg-6">
            <TextBox
              name="title"
              v-model="form.title"
              :disabled="form.processing"
              :error="form.errors.title"
            />
            <TextBox
              name="slug"
              v-model="form.slug"
              :disabled="form.processing"
              :error="form.errors.slug"
            />
            <TextBox
              name="seo_tags"
              v-model="form.seo_tags"
              :disabled="form.processing"
              :error="form.errors.seo_tags"
              helperText="Enter comma separated tags"
            />

            <FileInput
              name="thumbnail"
              v-model="form.thumbnail"
              :fileUrl="form.thumbnail_url"
              :disabled="form.processing"
              :error="form.errors.thumbnail"
              helperText="Upload svg file for better quality"
            />
            <StatusRadio
              v-model="form.isactive"
              :disabled="form.processing"
              :error="form.errors.isactive"
            />
          </div>
          <div class="col-lg-6">
            <TextBox
              type="editor"
              name="description"
              v-model="form.description"
              :disabled="form.processing"
              :error="form.errors.description"
            />
          </div>
          <div class="col-12">
            <hr />
            <div class="text-center text-lg-right">
              <button
                class="btn btn-primary w-25"
                type="submit"
                :disabled="form.processing"
                @click.prevent="submit"
              >
                <div
                  class="spinner-border spinner-border-sm"
                  role="status"
                  v-if="form.processing"
                ></div>
                <span v-else>Save</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </Screen>
</template>
<script>
import FileInput from "@/components/form/fileInput.vue";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import "@/helpers/summernote/summernote-bs4.min.js";
import "@/helpers/summernote/summernote-bs4.min.css";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    blissciplines: {
      type: [Object, Array],
      default: () => [],
    },
    formData: {
      type: [Object, Array],
      default: () => {},
    },
    submitUrl: {
      type: String,
      default: "",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AdvanceSelect: vSelect,
    FileInput,
  },
  data() {
    return {
      form: {},
      formSet: false,
      fileName: "Choose file",
    };
  },
  mounted() {
    setTimeout(() => {
      this.form = this.$inertia.form(this.formData);
      this.fileName = this.form.animation || "Choose file";
      this.form.animation = null;
      this.form.thumbnail = null;
      setTimeout(() => {
        this.formSet = true;
      });
    });
  },
  methods: {
    submit() {
      this.form.post(this.submitUrl, {
        onSuccess: () => this.form.reset(),
      });
    },
    fileOnChange(event) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = () => {
        this.fileName = event.target.files[0].name;
        this.form.animation = event.target.files[0];
      };
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.content-type-help {
  padding: 1rem;
  border: 2px solid var(--warning);
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}
</style>